/**
 * DASHBOARD-RPS-OVERVIEW-SKELETON.WIDGET
 * Skeleton adapté à dashboard-rps-overview.widget.tsx : une rangée de 6 DashboardNumber
 * (header + titre + icône/valeur) suivie de la ligne de résumé, avec un reflet qui balaie.
 */
import Skeleton, { SkeletonShine } from "@/components/skeleton"

const ITEM_COUNT = 6

function SkeletonNumberItem() {
  return (
    <div className="flex1 flex flex-dcol" style={{ gap: 8 }}>
      <Skeleton width={60} height={11} />
      <Skeleton width={90} height={14} />
      <Skeleton width={44} height={26} style={{ marginTop: 4 }} />
    </div>
  )
}

export default function DashboardRpsOverviewSkeletonWidget() {
  return (
    <div className="rel" style={{ overflow: "hidden" }}>
      <div className="flex">
        {Array.from({ length: ITEM_COUNT }).map((_, i) => (
          <SkeletonNumberItem key={i} />
        ))}
      </div>

      <Skeleton width={320} height={13} style={{ marginTop: 20 }} />

      <SkeletonShine />
    </div>
  )
}
